import { jsx as o, Fragment as R, jsxs as v } from "react/jsx-runtime";
import { useChatbotContext as L } from "../../hooks/useChatbotContext.js";
import { useState as S, useMemo as r, useRef as D } from "react";
import { SuggestionButton as U } from "./SuggestionButton.js";
import { AI_SUGGESTION_ID as f } from "../../constants.js";
import { useElementDimensions as B } from "../../hooks/useElementDimensions.js";
import { useAiSuggestions as b } from "../../hooks/useAiSuggestions.js";
import { BotThinkingDots as j } from "./BotThinkingDots.js";
const p = 2, W = 468, h = {
  id: "loading",
  message: "Loading...",
  triggerCondition: "after_every_chatbot_response"
};
function J() {
  const {
    chatbot: e,
    hasUserMessages: _,
    handleSuggestion: x,
    previouslyUsedSuggestions: N
  } = L(), [g, w] = S(
    N
  ), A = (s) => {
    x(s), s.currentTarget.dataset.message && w([...g, s.currentTarget.dataset.message]);
  }, y = e == null ? void 0 : e.suggestions.some(
    (s) => s.triggerCondition === "after_every_chatbot_response"
  ), C = e == null ? void 0 : e.suggestions.some(
    (s) => s.triggerCondition === "beginning_of_conversation"
  ), M = y ? !0 : C && !_, T = r(() => e ? e.suggestions.some((s) => s.id === f) : !1, [e]), { isLoading: i, aiSuggestions: u } = b(
    T
  ), n = r(() => {
    const k = [
      ...((e == null ? void 0 : e.suggestions) ?? []).filter(
        (l) => l.id !== f
      ),
      ...u,
      ...i ? [h] : []
    ], G = new Set(g);
    return k.filter((l) => !G.has(l.message));
  }, [
    e == null ? void 0 : e.suggestions,
    g,
    u,
    i
  ]), [a, E] = S(!1), I = () => {
    E(!0);
  }, d = D(null), { width: m } = B(d), c = m && m < W, t = r(() => c && !a ? n == null ? void 0 : n.slice(
    0,
    p
  ) : n, [n, c, a]), O = r(
    () => n && t && n.length > t.length && !(n.length === p + 1 && i),
    [n, t, i]
  );
  return /* @__PURE__ */ o(R, { children: t.length > 0 && M ? /* @__PURE__ */ v(
    "div",
    {
      ref: d,
      className: "mx-4 mb-3 mt-2 flex flex-col items-end gap-2 @notMobile:mx-5 @notMobile:mb-3.5",
      children: [
        /* @__PURE__ */ o("div", { className: "flex max-w-full flex-wrap items-center justify-end gap-2 transition empty:hidden", children: t.map(
          (s) => s.id === h.id ? /* @__PURE__ */ o("span", { className: "px-[13px] py-[9px]", children: /* @__PURE__ */ o(j, {}) }) : /* @__PURE__ */ o(
            U,
            {
              suggestion: s,
              onClick: A
            },
            s.id
          )
        ) }),
        O && /* @__PURE__ */ o(
          "button",
          {
            onClick: I,
            type: "button",
            className: "my-0.5 rounded-medium text-sm text-foreground underline ring ring-transparent ring-offset-2 ring-offset-background hover:no-underline focus-visible:ring-ring",
            children: e == null ? void 0 : e.moreSuggestionsLinkText
          }
        )
      ]
    }
  ) : null });
}
export {
  J as Suggestions
};
